import AgenciesList from 'pages/agents/AgenciesList';
import utilStyles from '../../asset/styles/util/util.module.scss';

const Agency = () => {
    return (
        <div className={`${utilStyles.pageContainer} ${utilStyles.listPageFill}`}>
            <AgenciesList />
        </div>
    )
};

export default Agency;